import * as _ from '@fr0st/core';
import { ajax, _delete, get, patch, post, put } from './ajax/ajax.js';
import { parseFormData, parseParams } from './ajax/helpers.js';
import { animate, stop } from './animation/animate.js';
import AnimationSet from './animation/animation-set.js';
import Animation from './animation/animation.js';
import { dropIn, dropOut, fadeIn, fadeOut, rotateIn, rotateOut, slideIn, slideOut, squeezeIn, squeezeOut } from './animation/animations.js';
import { getAttribute, getDataset, getHtml, getProperty, getText, getValue, removeAttribute, removeDataset, removeProperty, setAttribute, setDataset, setHtml, setProperty, setText, setValue } from './attributes/attributes.js';
import { cloneData, getData, removeData, setData } from './attributes/data.js';
import { center, constrain, distTo, distToNode, nearestTo, nearestToNode, percentX, percentY, position, rect } from './attributes/position.js';
import { getScrollX, getScrollY, setScroll, setScrollX, setScrollY } from './attributes/scroll.js';
import { height, width } from './attributes/size.js';
import { setStyleLock } from './attributes/style-locks.js';
import { addClass, css, getStyle, hide, removeClass, removeStyle, setStyle, show, toggle, toggleClass } from './attributes/styles.js';
import { getAjaxDefaults, getAnimationDefaults, getContext, getWindow, setAjaxDefaults, setAnimationDefaults, setContext, setWindow, useTimeout } from './config.js';
import { getCookie, removeCookie, setCookie } from './cookie/cookie.js';
import { mouseDragFactory } from './events/event-factory.js';
import { addEvent, addEventDelegate, addEventDelegateOnce, addEventOnce, cloneEvents, removeEvent, removeEventDelegate, triggerEvent, triggerOne } from './events/event-handlers.js';
import { blur, click, focus, ready } from './events/events.js';
import { noConflict } from './globals.js';
import { debounce } from './helpers.js';
import { attachShadow, create, createComment, createFragment, createRange, createText } from './manipulation/create.js';
import { clone, detach, empty, remove, replaceAll, replaceWith } from './manipulation/manipulation.js';
import { after, append, appendTo, before, insertAfter, insertBefore, prepend, prependTo } from './manipulation/move.js';
import { unwrap, wrap, wrapAll, wrapInner } from './manipulation/wrap.js';
import { parseDocument, parseHtml } from './parser/parser.js';
import QuerySet from './query/query-set.js';
import { query, queryOne } from './query/query.js';
import { clearQueue, queue } from './queue/queue.js';
import { loadScript, loadScripts } from './scripts/scripts.js';
import { loadStyle, loadStyles } from './styles/styles.js';
import { connected, equal, filter, filterOne, fixed, hidden, not, notOne, same, visible, withAnimation, withAttribute, withChildren, withClass, withCssAnimation, withCssTransition, withData, withDescendent, withProperty } from './traversal/filter.js';
import { find, findByClass, findById, findByTag, findOne, findOneByClass, findOneById, findOneByTag } from './traversal/find.js';
import { child, children, closest, commonAncestor, contents, fragment, next, nextAll, offsetParent, parent, parents, prev, prevAll, shadow, siblings } from './traversal/traversal.js';
import { sanitize } from './utility/sanitize.js';
import { afterSelection, beforeSelection, extractSelection, getSelection, select, selectAll, wrapSelection } from './utility/selection.js';
import { hasAnimation, hasAttribute, hasChildren, hasClass, hasCssAnimation, hasCssTransition, hasData, hasDataset, hasDescendent, hasFragment, hasProperty, hasShadow, is, isConnected, isEqual, isFixed, isHidden, isSame, isVisible } from './utility/tests.js';
import { exec, index, indexOf, normalize, serialize, serializeArray, sort, tagName } from './utility/utility.js';
import { BORDER_BOX, CONTENT_BOX, MARGIN_BOX, PADDING_BOX, SCROLL_BOX } from './vars.js';

Object.assign(query, {
    BORDER_BOX,
    CONTENT_BOX,
    MARGIN_BOX,
    PADDING_BOX,
    SCROLL_BOX,
    Animation,
    AnimationSet,
    QuerySet,
    addClass,
    addEvent,
    addEventDelegate,
    addEventDelegateOnce,
    addEventOnce,
    after,
    afterSelection,
    ajax,
    animate,
    append,
    appendTo,
    attachShadow,
    before,
    beforeSelection,
    blur,
    center,
    child,
    children,
    clearQueue,
    click,
    clone,
    cloneData,
    cloneEvents,
    closest,
    commonAncestor,
    connected,
    constrain,
    contents,
    create,
    createComment,
    createFragment,
    createRange,
    createText,
    css,
    debounce,
    delete: _delete,
    detach,
    distTo,
    distToNode,
    dropIn,
    dropOut,
    empty,
    equal,
    exec,
    extractSelection,
    fadeIn,
    fadeOut,
    filter,
    filterOne,
    find,
    findByClass,
    findById,
    findByTag,
    findOne,
    findOneByClass,
    findOneById,
    findOneByTag,
    fixed,
    focus,
    fragment,
    get,
    getAjaxDefaults,
    getAnimationDefaults,
    getAttribute,
    getContext,
    getCookie,
    getData,
    getDataset,
    getHtml,
    getProperty,
    getScrollX,
    getScrollY,
    getSelection,
    getStyle,
    getText,
    getValue,
    getWindow,
    hasAnimation,
    hasAttribute,
    hasCssAnimation,
    hasCssTransition,
    hasChildren,
    hasClass,
    hasData,
    hasDataset,
    hasDescendent,
    hasFragment,
    hasProperty,
    hasShadow,
    height,
    hidden,
    hide,
    index,
    indexOf,
    insertAfter,
    insertBefore,
    is,
    isConnected,
    isEqual,
    isFixed,
    isHidden,
    isSame,
    isVisible,
    loadScript,
    loadScripts,
    loadStyle,
    loadStyles,
    mouseDragFactory,
    nearestTo,
    nearestToNode,
    next,
    nextAll,
    noConflict,
    normalize,
    not,
    notOne,
    offsetParent,
    parent,
    parents,
    parseDocument,
    parseFormData,
    parseHtml,
    parseParams,
    patch,
    percentX,
    percentY,
    position,
    post,
    prepend,
    prependTo,
    prev,
    prevAll,
    put,
    query,
    queryOne,
    queue,
    ready,
    rect,
    remove,
    removeAttribute,
    removeClass,
    removeCookie,
    removeData,
    removeDataset,
    removeEvent,
    removeEventDelegate,
    removeProperty,
    removeStyle,
    replaceAll,
    replaceWith,
    rotateIn,
    rotateOut,
    same,
    sanitize,
    select,
    selectAll,
    serialize,
    serializeArray,
    setAjaxDefaults,
    setAnimationDefaults,
    setAttribute,
    setContext,
    setCookie,
    setData,
    setDataset,
    setHtml,
    setProperty,
    setScroll,
    setScrollX,
    setScrollY,
    setStyle,
    setStyleLock,
    setText,
    setValue,
    setWindow,
    shadow,
    show,
    siblings,
    slideIn,
    slideOut,
    sort,
    squeezeIn,
    squeezeOut,
    stop,
    tagName,
    toggle,
    toggleClass,
    triggerEvent,
    triggerOne,
    unwrap,
    useTimeout,
    visible,
    width,
    withAnimation,
    withAttribute,
    withCssAnimation,
    withCssTransition,
    withChildren,
    withClass,
    withData,
    withDescendent,
    withProperty,
    wrap,
    wrapAll,
    wrapInner,
    wrapSelection,
});

for (const [key, value] of Object.entries(_)) {
    query[`_${key}`] = value;
}

export default query;
